import { EventLocationTypeEnum, OfflineEventProps } from '@/types/schema';

export const DEFAULT_LOCATION_PROPS: OfflineEventProps = {
  location: { type: EventLocationTypeEnum.Custom, customLocation: '' },
};
